module.exports = __webpack_public_path__ + "img/yhrs_logo.25c7f977.png";